import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const productitemApi = {
  purchase_status (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/productitems/purchase_status/`, {params: params})
  }
}

export default productitemApi
